<template>
    <nav v-if="!loadingData">
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-row v-if="page == 'order'">
            <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
                <p class="text-h4 mb-10 mt-6">{{ $t('createOrderTitle') }}</p>
                <p class="grey--text">{{ storeProduct.attributes.title }}</p>
                <p class="mb-5">{{ $t('storeOrderPricePerPerson') }}<span class="d-block font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ price }}</span></p>
                <v-form ref="form" @submit.prevent>
                    <v-card rounded="xxl" class="mx-auto pa-5 mb-10">
                        <v-card-title>
                            <p>{{ $t('orderInvoiceReference') }}</p>
                        </v-card-title>
                        <v-card-title class="pb-0">
                            <p>{{ $t('orderClientReference') }}</p>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="firstName"
                                        data-testid="first-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderFirstNamePlaceholder')"
                                        :rules="firstNameRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="lastName"
                                        data-testid="last-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderLastNamePlaceholder')"
                                        :rules="lastNameRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="email"
                                        data-testid="email-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderEmailPlaceholder')"
                                        :rules="emailRulesWithLimit"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="invoiceEmail"
                                        data-testid="invoice-email-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderInvoiceEmailPlaceholder')"
                                        :rules="emailRulesWithLimit"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-title class="pb-0">
                            <p class="row-pointer" :class="privatePerson == false ? 'accent--text' : ''" @click="privatePerson = false">{{ $t('orderCompanyReference') }}</p>
                            <p class="row-pointer ml-5" :class="privatePerson == true ? 'accent--text' : ''" @click="privatePerson = true">{{ $t('orderPrivatePersonReference') }}</p>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-show="privatePerson == false"
                                        v-model="companyName"
                                        data-testid="company-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderCompanyNamePlaceholder')"
                                        :rules="companyNameRules"
                                        @keydown.enter.prevent
                                    />
                                    <v-text-field
                                        v-show="privatePerson == true"
                                        v-model="personalName"
                                        data-testid="personal-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderPersonalNamePlaceholder')"
                                        :rules="personalNameRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-show="privatePerson == false"
                                        v-model="organizationNumber"
                                        data-testid="organization-number-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderOrganizationNumberPlaceholder')"
                                        :rules="organizationNumberRules"
                                        @keydown.enter.prevent
                                    />
                                    <v-text-field
                                        v-show="privatePerson == true"
                                        v-model="personalNumber"
                                        data-testid="personal-number-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderPersonalNumberPlaceholder')"
                                        :rules="personalNumberRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-show="privatePerson == false"
                                        v-model="companyAddress"
                                        data-testid="company-address-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderCompanyAddressPlaceholder')"
                                        :rules="companyAddressRules"
                                        @keydown.enter.prevent
                                    />
                                    <v-text-field
                                        v-show="privatePerson == true"
                                        v-model="personalAddress"
                                        data-testid="post-address-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderPersonalAddressPlaceholder')"
                                        :rules="personalAddressRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-show="privatePerson == false"
                                        v-model="city"
                                        data-testid="city-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderCityPlaceholder')"
                                        :rules="cityRules"
                                        @keydown.enter.prevent
                                    />
                                    <v-text-field
                                        v-show="privatePerson == true"
                                        v-model="personalCity"
                                        data-testid="personal-city-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderCityPlaceholder')"
                                        :rules="personalCityRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-show="privatePerson == false"
                                        v-model="postCode"
                                        data-testid="post-code-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderPostCodePlaceholder')"
                                        :rules="postCodeRules"
                                        @keydown.enter.prevent
                                    />
                                    <v-text-field
                                        v-show="privatePerson == true"
                                        v-model="personalPostCode"
                                        data-testid="personal-post-code-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderPostCodePlaceholder')"
                                        :rules="personalPostCodeRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card rounded="xxl" class="mx-auto pa-5">
                        <v-card-title>
                            <p>{{ $t('createOrderAddParticipantsTitle') }}</p>
                        </v-card-title>
                        <v-card-text>
                            <v-row v-for="(participant, index) in participants" :key="index">
                                <div style="width: 100%;" v-if="index != 0" class="my-2 px-5"><v-divider light></v-divider></div>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="participant.first_name"
                                        data-testid="participant-first-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderFirstNamePlaceholder')"
                                        :rules="firstNameRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="participant.last_name"
                                        data-testid="participant-last-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderLastNamePlaceholder')"
                                        :rules="lastNameRules"
                                        @keydown.enter.prevent
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="participant.email"
                                        data-testid="participant-email-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createOrderEmailPlaceholder')"
                                        :rules="emailRulesWithLimit"
                                        @keydown.enter.prevent
                                    >
                                        <template v-slot:append-outer v-if="Object.keys(additionalAttributesForParticipants).length === 0">
                                            <v-btn v-if="participants.length > 1" icon small color="error" @click="removeParticipant(index)"><v-icon>mdi-delete-circle</v-icon></v-btn>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col v-for="(value, name, index2) in additionalAttributesForParticipants" :key="index2" cols="12">
                                    <v-text-field
                                        v-model="participant[name]"
                                        :data-testid="'participant-'+name+'-input'"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="value.required ? $t(name) : $t(name) + ' (' + $t('labelOptional') + ')'"
                                        :rules="defineRules(name, value)"
                                        @keydown.enter.prevent
                                    >
                                        <template v-slot:append-outer v-if="index2 == Object.keys(additionalAttributesForParticipants).length - 1">
                                            <v-btn v-if="participants.length > 1" icon small color="error" @click="removeParticipant(index)"><v-icon>mdi-delete-circle</v-icon></v-btn>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <div class="text-right mt-5 mr-9">
                        <v-tooltip bottom v-if="participants.length >= availableSeats && availableSeats !== null" >
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="d-inline-block">
                                    <v-btn fab small color="accent" :disabled="participants.length >= availableSeats" data-testid="add-participant-button"><v-icon>mdi-plus</v-icon></v-btn>
                                </div>
                            </template>
                            <span>{{$t('notAvailableSeatsTooltip')}}</span>
                        </v-tooltip>
                        <v-btn v-else fab small color="accent" @click="addParticipant" data-testid="add-participant-button"><v-icon>mdi-plus</v-icon></v-btn>
                    </div>
                    <v-row>
                        <v-col cols="12" align="center" class="mb-n12">
                            <div>
                                <span>{{ $t('total') }}: </span>
                                <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ total_price }}</span>
                            </div>
                            <div v-if="storeProduct.attributes.tax != null && storeProduct.attributes.tax != 0">
                                <span >{{ $t('totalWithTax') }}: </span>
                                <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ totalWithtax }}</span>
                            </div>
                        </v-col>
                        <v-col cols="12" align="center">
                            <FormFooter next-button-text="continueBtn" next-button-color="success" :next-icon="false" @proceedSubmit="previewOrder" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-row v-else-if="page == 'preview'" align="center" justify="center" class="fill-height">
            <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center" class="mx-auto px-0">
                <p class="text-h4 mb-10 text-center">{{ $t('createOrderPreviewTitle') }}</p>
                <!-- <p class="grey--text">{{ $t('createOrderPreviewText') }}</p> -->
                <v-card rounded="xxl" class="mx-auto pa-5 mb-10">
                    <v-card-title>
                        <p>{{ $t('orderInvoiceReference') }}</p>
                    </v-card-title>
                    <v-card-title class="pb-0">
                        <p>{{ $t('orderClientReference') }}</p>
                    </v-card-title>
                    <v-card-text class="text-left">
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelName') }}: </span>{{ this.firstName }} {{ this.lastName }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelEmail') }}: </span>{{ this.email }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelInvoiceEmail') }}: </span>{{ this.invoiceEmail }}</p>
                    </v-card-text>
                    <v-card-title class="pb-0">
                        <p>{{ privatePerson == true ? $t('orderPrivatePersonReference') : $t('orderCompanyReference') }}</p>
                    </v-card-title>
                    <v-card-text class="text-left">
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ privatePerson == true ? $t('labelPrivatePerson') : $t('labelCompany') }}: </span>{{ privatePerson == true ? this.personalName : this.companyName }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ privatePerson == true ? $t('labelPersonalNumber') : $t('labelOrganizationNumber') }}: </span>{{ privatePerson == true ? this.personalNumber : this.organizationNumber }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ privatePerson == true ? $t('labelPersonalAddress') : $t('labelCompanyAddress') }}: </span>{{ privatePerson == true ? this.personalAddress : this.companyAddress }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{  $t('labelCity') }}: </span>{{ privatePerson == true ? this.personalCity : this.city }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelPostCode') }}: </span>{{ privatePerson == true ? this.personalPostCode : this.postCode }}</p>
                    </v-card-text>
                </v-card>
                <v-card rounded="xxl" class="mx-auto pa-5">
                    <v-card-title>
                        <p>{{ $t('orderParticipantsTitle') }}</p>
                    </v-card-title>
                    <v-card-text v-for="(participant, index) in participants" :key="index" class="text-left pb-0">
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelName') }}: </span>{{ participant.first_name }} {{ participant.last_name }}</p>
                        <p class="darktext--text text-body-2"><span class="grey--text">{{ $t('labelEmail') }}: </span>{{ participant.email }}</p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" align="center" class="mb-n12 mt-15 pt-0">
                <div>
                    <span>{{ $t('total') }}: </span>
                    <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ total_price }}</span>
                </div>
                <div v-if="storeProduct.attributes.tax != null && storeProduct.attributes.tax != 0">
                    <span >{{ $t('totalWithTax') }}: </span>
                    <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ totalWithtax }}</span>
                </div>
            </v-col>
            <v-col v-if="policyText != null" cols="12" sm="8" md="6" offset-sm="2" offset-md="3" class="mx-auto px-0 d-flex mt-10 mb-n5">
                <div class="text-center mx-auto">
                    <v-checkbox
                        data-testid="policy-checkbox"
                        v-model="acceptedPolicy"
                        color="accent"
                        class="pa-2"
                        hide-details
                        @change="acceptPolicy($event)"
                    >
                        <template v-slot:label>
                            <!-- eslint-disable vue/no-v-html -->
                            <div
                                class="text-body-2 greytext--text"
                                ref="link"
                            >
                                <a v-if="policyLinkText != null" target='_blank' href='/store/policy'>{{ policyLinkText }}</a>
                                <a v-else target='_blank' href='/store/policy'>{{ $t('purchasePolicyLinkTextDefault') }}</a>
                            </div>
                        </template>
                    </v-checkbox>
                </div>
            </v-col>
            <v-col cols="12" align="center">
                <nav>
                    <v-btn
                        data-testid="back-button"
                        outlined
                        elevation="0"
                        class="rounded-xxl text-none px-4 mr-8"
                        :class="policyText !== null ? 'mt-0' : 'mt-10'"
                        @click="page = 'order'"
                        >
                        {{ $t('editOrder') }}
                        </v-btn>
                        <v-btn
                            data-testid="submit-button"
                            type="submit"
                            color="success"
                            :class="policyText !== null ? 'mt-0' : 'mt-10'"
                            class="rounded-xxl text-none white--text px-4"
                            @click="createOrder"
                            :disabled="buttonDisabled"
                        >
                        {{ $t('confirm') }}
                    </v-btn>
                </nav>
            </v-col>
        </v-row>
        <v-row v-else align="center" justify="center" class="fill-height">
            <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center" class="mx-auto px-0">
                <p class="text-h4 mb-10 text-center">{{ $t('createOrderSuccessTitle') }}</p>
                <p class="grey--text">{{ $t('createOrderSuccessText') }}</p>
                <v-card rounded="xxl" class="mx-auto pa-5 mt-10" max-width="400">
                    <v-card-title class="justify-center">{{ $t('createOrderSuccessSummaryTitle') }}</v-card-title>
                    <v-card-subtitle>{{ storeProduct.attributes.title }}</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text class="d-flex justify-space-between pb-0">
                        <span>{{ $t('createOrderSuccessSummaryNumberOfParticipants') }}:</span>
                        <span class="font-weight-bold">{{ participants.length }}</span>
                    </v-card-text>
                    <v-card-text class="d-flex justify-space-between py-0">
                        <span>{{ $t('price') }}:</span>
                        <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ total_price }}</span>
                    </v-card-text>
                    <v-card-text class="d-flex justify-space-between py-0" v-if="storeProduct.attributes.tax != null ">
                        <span  data-testid="with-tax"  >{{ $t('tax') }}: </span>
                        <span class="font-weight-bold">{{ storeProduct.attributes.tax}} %</span>  
                    </v-card-text>
                    <v-card-text class="d-flex justify-space-between py-0" v-else>
                        <span  data-testid="without-tax" >{{ $t('tax') }}:</span>
                        <span class="font-weight-bold"> 0% </span>
                    </v-card-text>
                    <v-card-text class="d-flex justify-space-between py-0" v-if="storeProduct.attributes.tax != null ">
                        <span  data-testid="with-tax"  >{{ $t('total') }}: </span>
                        <span class="font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ totalWithtax }}</span>  
                    </v-card-text>
                    <v-card-text class="d-flex justify-space-between py-0" v-else>
                        <span  data-testid="without-tax" >{{ $t('total') }}:</span>
                        <span class="font-weight-bold"> {{ storeProduct.attributes.currency.code }} {{ total_price }} </span>
                   </v-card-text>
                </v-card>
                <v-btn class="rounded-xxl text-none px-4 mt-10 white--text" color="darktext" @click="redirectToProduct">{{ $t('createOrderSuccessSummaryButton') }}</v-btn>
            </v-col>
        </v-row>
    </nav>
</template>
<script>
import { getStoreProductPublic, createOrder, getStorePurchasePolicy } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import  FormFooter  from '../../components/FormFooter'
import { ruleRequired, emailRuleValid, ruleValidMin2Max70Characters, ruleValidMinMax, phoneNumberRules2 } from '../../rules/formRules.js';

export default {
    components: {
        AlertMessages,
        FormFooter
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            storeProduct: {},
            productID: this.$route.params.id,
            space: window.location.host.split('.')[0],
            registerDisabled: true,
            participants: [
                {
                    first_name: '',
                    last_name: '',
                    email: ''
                }
            ],
            focusNext(elem) {
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(
                    currentIndex < elem.form.elements.length - 1 ?
                    currentIndex + 1 :
                    0
                ).focus();
            },
            firstName: '',
            lastName: '',
            email: '',
            invoiceEmail: '',
            companyName: '',
            personalName: '',
            organizationNumber: '',
            personalNumber: '',
            companyAddress: '',
            personalAddress: '',
            city: '',
            personalCity: '',
            postCode: '',
            personalPostCode: '',
            firstNameRules: ruleRequired('labelFirstName').concat(ruleValidMin2Max70Characters('labelFirstName')),
            lastNameRules: ruleRequired('labelLastName').concat(ruleValidMin2Max70Characters('labelLastName')),
            emailRules: ruleRequired('labelEmail').concat(emailRuleValid),
            emailRulesWithLimit: ruleRequired('labelEmail').concat(emailRuleValid).concat(ruleValidMinMax('labelEmail', 2, 255)),
            companyNameRules: ruleRequired('labelCompanyName').concat(ruleValidMinMax('labelCompanyName', 2, 255)),
            personalNameRules: [],
            organizationNumberRules: ruleRequired('labelOrganizationNumber').concat(ruleValidMinMax('labelOrganizationNumber', 2, 255)),
            personalNumberRules: [],
            companyAddressRules: ruleRequired('labelCompanyAddress').concat(ruleValidMinMax('labelCompanyAddress', 2, 255)),
            personalAddressRules: [],
            cityRules: ruleRequired('labelCity').concat(ruleValidMinMax('labelCity', 2, 255)),
            personalCityRules: [],
            postCodeRules: ruleRequired('labelPostCode').concat(ruleValidMinMax('labelPostCode', 2, 255)),
            personalPostCodeRules: [],
            showSuccessCard: false,
            price:0,
            total_price:0,
            total:0,
            totalWithtax:0,
            availableSeats: null,
            page: 'order',
            tax: null,
            policyLinkText: null,
            policyText: null,
            buttonDisabled: false,
            acceptedPolicy: false,
            additionalAttributesForParticipants: [],
            privatePerson: false
        }
    },

    watch: {
        participants() {
            this.total = this.storeProduct.attributes.price * this.participants.length;
            this.total_price = this.total.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
            this.totalWithtax = Math.round(this.total * (1 + this.storeProduct.attributes.tax / 100))
            this.totalWithtax = this.totalWithtax.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
        },
        page() {
            if (this.page == 'preview') {
                this.$nextTick(() => {
                    if(this.policyText != null){
                        this.$refs['link'].children[0].addEventListener('click', function(event) {
                            event.stopImmediatePropagation()
                        })
                    }
                })
            }
        },
        privatePerson() {
            if (this.privatePerson) {
                this.companyNameRules = []
                this.organizationNumberRules = []
                this.companyAddressRules = []
                this.cityRules = []
                this.postCodeRules = []
                this.personalNameRules = ruleRequired('labelPersonalName').concat(ruleValidMinMax('labelPersonalName', 2, 255))
                this.personalNumberRules = ruleRequired('labelPersonalNumber').concat(ruleValidMinMax('labelPersonalNumber', 2, 255))
                this.personalAddressRules = ruleRequired('labelPersonalAddress').concat(ruleValidMinMax('labelPersonalAddress', 2, 255))
                this.personalCityRules = ruleRequired('labelCity').concat(ruleValidMinMax('labelCity', 2, 255))
                this.personalPostCodeRules = ruleRequired('labelPostCode').concat(ruleValidMinMax('labelPostCode', 2, 255))
            } else {
                this.companyNameRules = ruleRequired('labelCompanyName').concat(ruleValidMinMax('labelCompanyName', 2, 255))
                this.organizationNumberRules = ruleRequired('labelOrganizationNumber').concat(ruleValidMinMax('labelOrganizationNumber', 2, 255))
                this.companyAddressRules = ruleRequired('labelCompanyAddress').concat(ruleValidMinMax('labelCompanyAddress', 2, 255))
                this.cityRules = ruleRequired('labelCity').concat(ruleValidMinMax('labelCity', 2, 255))
                this.postCodeRules = ruleRequired('labelPostCode').concat(ruleValidMinMax('labelPostCode', 2, 255))
                this.personalNumberRules = []
                this.personalNameRules = []
                this.personalAddressRules = []
                this.personalCityRules = []
                this.personalPostCodeRules = []
            }
        }
    },
    
    async created(){      
        this.loadingData = true
        await this.fetchStoreProduct()
        await this.fetchStoreSettings()
        this.loadingData = false;
        
        i18n.locale = window.$cookies.get('language') ? window.$cookies.get('language') : window.$cookies.get('space_language') ? window.$cookies.get('space_language') : 'sv';
    },
    methods:{
        acceptPolicy: function(e) {
            this.buttonDisabled = e === true ? false : true
        },
        async fetchStoreProduct() {
            try {
                const response = await getStoreProductPublic(this.productID);
                if (response.status == 200) {
                    this.storeProduct = response.data.data
                    this.price = this.storeProduct.attributes.price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
                    this.total = this.storeProduct.attributes.price;
                    this.total_price = this.total.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
                    this.totalWithtax = Math.round(this.total * (1 + this.storeProduct.attributes.tax / 100))
                    this.totalWithtax = this.totalWithtax.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
                    this.registerDisabled = false
                    this.availableSeats = this.storeProduct.attributes.participants_seats_left
                    this.tax = this.storeProduct.attributes.tax
                    this.additionalAttributesForParticipants = this.storeProduct.attributes.additional_attributes_for_participants
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },

        async fetchStoreSettings() {
            try {
                const response = await getStorePurchasePolicy(this.spaceId);
                if (response.status == 200) {
                    this.policyLinkText = response.data.meta.policy.policy_link_text
                    this.policyText = response.data.meta.policy.policy_text
                    if(this.policyText !== null){
                        this.buttonDisabled = true
                    }
                }
            } catch (e) {
                if (e.response) {
                if (e.response.status == 404) {
                    this.$router.push({ name: 'PageNotFound' })
                }
                else if (e.response.status == 403) {
                    this.$router.push({ name: 'PageAccessDenied' })
                } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg = i18n.t('serverError')
                }
                }
            }
        },
        addParticipant(){
            this.participants.push({
                first_name: '',
                last_name: '',
                email: ''
            })
        },
        removeParticipant(index){
            this.participants.splice(index, 1)
        },
        previewOrder(){
            this.valid = this.$refs.form.validate()
            if(this.valid){
                const emails = this.participants.map(participant => participant.email.toLowerCase());
                const emailsUnique = [...new Set(emails)];
                if(emails.length == emailsUnique.length){
                    this.page = 'preview'
                } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg = i18n.t('createOrderErrorDuplicateEmails')
                }
            }
        },
        defineRules(name, value){
            let rules = []
            if (name == 'phone') {
                rules = phoneNumberRules2.concat(ruleValidMinMax('phone', 6, 20))
            } else if (name == 'personal_number') {
                rules = ruleValidMinMax('personal_number', 8, 20)
            } else if (rules) {
                rules = rules.concat(ruleValidMinMax(name, 2, 255))
            } else {
                rules = ruleValidMinMax(name, 2, 255)
            }

            if (value.required) {
                if (rules) {
                    rules = rules.concat(ruleRequired(name))
                } else {
                    rules = ruleRequired(name)
                }
            }

            return rules
        },
        async createOrder(){
            if(this.policyText == null || (this.policyText !== null && this.acceptedPolicy)) {
                this.buttonDisabled = true           
                try {
                    let data = {
                        data: {
                            type: "store-orders",
                            attributes: {
                                'first_name': this.firstName,
                                'last_name': this.lastName,
                                'email': this.email,
                                'invoice_email': this.invoiceEmail,
                                'private_person': this.privatePerson,
                                'company_name': this.privatePerson == false ? this.companyName : this.personalName,
                                'organization_number': this.privatePerson == false ? this.organizationNumber : this.personalNumber,
                                'company_address': this.privatePerson == false ? this.companyAddress : this.personalAddress,
                                'city': this.privatePerson == false ? this.city : this.personalCity,
                                'post_code': this.privatePerson == false ? this.postCode : this.personalPostCode,
                                'total_price': this.storeProduct.attributes.price * this.participants.length,
                                'currency_id': this.storeProduct.attributes.currency.id,
                                'participants': this.participants.map((participant) => ({
                                    ...participant,
                                    email: participant.email.toLowerCase(),
                                })),
                                'tax': this.tax
                            },
                            relationships: {
                                space: {
                                    data: {
                                        type: "spaces",
                                        id: this.spaceId
                                    }
                                },
                                "product": {
                                    data: {
                                        type: "store-products",
                                        id: this.productID
                                    }
                                }
                            }
                        }
                    };

                    var response = await createOrder(data);
                    if(response.status == 201) {
                        this.page = 'success'
                    }
                } catch (e) {
                    if(e.response){
                        if (e.response.status == 403){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'Participant Limit is reached'){
                                    this.dialogVisibleApproveDenyOrder = false
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('storeOrderAvailableSeatsError')
                                }
                                else {
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('serverError')
                                }
                            }     
                        } else {
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                        
                    }
                }
                this.buttonDisabled = false
            }
        },
        redirectToProduct(){
            this.$router.push({name: 'ViewProductPublic', params: {id: this.productID}})
        }
    }
}
</script>